/// <reference types="./set-operation-parser.d.ts" />
import { SetOperationNode, } from '../operation-node/set-operation-node.js';
export function parseSetOperation(operator, expression, all) {
    return SetOperationNode.create(operator, expression.toOperationNode(), all);
}
